export const PERSPECTIVES = [
  { id: 'experts',        name_en: 'Experts',       name_de: 'Experten',              name_fr: 'Experts'         },
  { id: 'participants',   name_en: 'In the Room',   name_de: 'Im Saal',               name_fr: 'Dans la salle'   },
  { id: 'future_leaders', name_en: 'Students',      name_de: 'Studierende',           name_fr: 'Étudiants'       },
  { id: 'public',         name_en: 'Broad Public',  name_de: 'Breite Öffentlichkeit', name_fr: 'Grand public'    },
];
